import React, {
    useContext
} from 'react';
import { renderContentFromMetadata } from '@jutro/uiconfig';
import _ from 'lodash';
import { TranslatorContext } from '@jutro/locale';
import metadata from './SgVehicleChangesSummary.metadata.json5';
import messages from './SgVehicleChangesSummary.messages';

function SgVehicleChangesSummary(props) {
    const {
        modelVM,
        changes,
        getValue,
    } = props;

    const translator = useContext(TranslatorContext);
    const { spmVehicle } = modelVM.lobData.privateMotor.coverables;

    const getModificationString = ((modifications) => {
        let modificationString = '';
        _.each(modifications, (mod, index) => {
            if (index > 0) {
                modificationString += ', ';
            }
            modificationString += mod;
        });
        return modificationString;
    });

    const overrideProps = {
        vehicle: {
            visible: !_.isNil(changes.vehicle),
            content: !_.isNil(changes.vehicle)
                ? (
                    <>
                        {translator(messages.VehicleChange,
                            { vehicle: <p>{`${changes.vehicle.registration}, ${changes.vehicle.make}, ${changes.vehicle.model}`}</p> })}
                    </>
                ) : null
        },
        registration: {
            visible: !_.isNil(changes.registrationNumber),
            content: !_.isNil(changes.registrationNumber)
                ? (
                    <>
                        {translator(messages.RegChange, { registration: <p>{changes.registrationNumber }</p> })}
                        <p>{translator(messages.OnExistingVehicle, { make: spmVehicle.value.make, model: spmVehicle.value.model })}</p>
                    </>
                ) : null
        },
        addedModification: {
            visible: !_.isNil(changes.addedModification),
            content: !_.isNil(changes.addedModification)
                ? (
                    <>
                        {translator(messages.ModificationAdded, { modification: <p>{getModificationString(changes.addedModification)}</p> })}
                    </>
                ) : null
        },
        removedModification: {
            visible: !_.isNil(changes.removedModification),
            content: !_.isNil(changes.removedModification)
                ? (
                    <>
                        {translator(messages.ModificationRemoved, { modification: <p>{getModificationString(changes.removedModification)}</p> })}
                    </>
                ) : null
        },
        mileage: {
            visible: !_.isNil(changes.mileage),
            content: !_.isNil(changes.mileage)
                ? (
                    <>
                        {translator(messages.MileageChange, { mileage: <p>{getValue(changes.mileage)}</p> })}
                    </>
                ) : null
        },
        vehicleUse: {
            visible: !_.isNil(changes.vehicleUse),
            content: !_.isNil(changes.vehicleUse)
                ? (
                    <>
                        {translator(messages.VehicleUseChange, { use: <p>{getValue(changes.vehicleUse)}</p> })}
                    </>
                ) : null
        },
        vehicleParkingType: {
            visible: !_.isNil(changes.vehicleParkingType),
            content: !_.isNil(changes.vehicleParkingType)
                ? (
                    <>
                        {translator(messages.VehicleParkingChange, { parking: <p>{getValue(changes.vehicleParkingType)}</p> })}
                    </>
                ) : null
        }
    };

    const resolvers = {
        resolveCallbackMap: {},
        resolveComponentMap: {}
    };

    return renderContentFromMetadata(metadata.componentContent, overrideProps, resolvers);
}

export default SgVehicleChangesSummary;
